<template>
    <UiSearchboxJetparkSearchBox v-editable="blok" data-test="sb-jetpark-searchbox" :terminals="blok.terminals" />
</template>

<script setup lang="ts">
defineProps<{ blok: any }>();
</script>

<style scoped lang="postcss"></style>
